<template lang="html">
  <div class="share">
    <div>
      <h2 class="text-xl px-8 p-4">
        Share: <b>{{ $attrs.question }}</b>
      </h2>
    </div>
    <div class="p-8 bg-gray-300">
      <div>
        <p><b>Poll web link</b></p>
        <div
          class="py-4 px-4 border border-gray-600 search block w-full bg-white mt-2"
        >
          {{ getBaseurl + $attrs.name }}
        </div>
        <br />
        <button
          class="cursor-pointer bg-push-blue mr-2 py-2 text-white uppercase px-8 inline-block"
          v-clipboard:copy="getBaseurl + $attrs.name"
          v-on:click="copiedLink = $attrs.name"
        >
          <span v-if="copiedLink != $attrs.name">Copy Link!</span>
          <span v-if="copiedLink === $attrs.name">Copied!</span>
        </button>
      </div>

      <div class="mt-4">
        <p><b>Embed code</b></p>
        <div
          class="py-4 px-4 border border-gray-600 search block w-full bg-white mt-2"
        >
          {{ renderIframe($attrs.name) }}
        </div>
        <br />
        <button
          class=" cursor-pointer bg-push-blue mr-2 py-2 text-white uppercase px-8 inline-block"
          v-clipboard:copy="renderIframe($attrs.name)"
          v-on:click="copiedCode = $attrs.name"
        >
          <span v-if="copiedCode != $attrs.name">Copy Code!</span>
          <span v-if="copiedCode === $attrs.name">Copied!</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copiedLink: null,
      copiedCode: null
    };
  },
  computed: {
    getBaseurl: function() {
      const url = "https://" + window.location.host;
      var baseUrl = null;
      if (this.$attrs.type == "group") {
        baseUrl = url + "/group/";
      } else {
        baseUrl = url + "/polls/";
      }
      return baseUrl;
    }
  },
  mounted() {
    this.renderIframe();
  },
  methods: {
    renderIframe: function(name) {
      var theurl = this.getBaseurl + name;
      var string =
        '<iframe  width="100%" height="1000" frameborder=0 src="' +
        theurl +
        '" name="push_embed"></iframe>';
      return string;
    }
  }
};
</script>
